import React, { HTMLAttributes } from "react";
import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`;

const Title = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
`;

interface DashboardContentProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
}

const DashboardContent = React.forwardRef(({title, isLoading, children, ...rest}: DashboardContentProps, ref: React.ForwardedRef<HTMLDivElement>) => {
  return <Container ref={ref} {...rest}>
    <Title>{title}</Title>
    {isLoading ? <div></div> : children}
  </Container>
})

export default DashboardContent;